export default __webpack_public_path__ + "static/media/downarrow.9158f0fa.svg";